<template>
  <modal
    name="modal--edit-recipe"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="350"
    :height="'auto'"
    :adaptive="true"
    :reset="true"
    :scrollable="true"
    draggable=".drag-handler"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    class="py-10"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4"
    >
      <div
        class="text-center text-4xl mb-3 font-extralight tracking-tight drag-handler"
      >
        {{ this.new === true ? 'New Recipe' : 'Edit Recipe' }}
      </div>

      <form @submit.prevent="handleConfirm" autocomplete="off">
        <fieldset :disabled="!isAdmin" class="border-0 p-0 m-0">
        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Recipe Name
          <input
            class="focus:outline-none focus:shadow-outline appearance-none block w-full text-base font-normal bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:bg-white focus:border-gray-500 mt-2"
            type="text"
            placeholder="(e.g. Spoons)"
            v-model.lazy="recipe.name"
            autocomplete="off"
          />
        </label>

        <!-- <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        > -->
        <!-- Recipe Ingredients
          <textarea
            class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
            type="text"
            placeholder=""
            v-model.lazy="recipe.ingredients"
            autocomplete="off"
          /> -->
        <list-ingredients
          :label="'Ingredients'"
          placeholder="Add Ingredient"
          :list="recipe.ingredients"
          :readonly="!isAdmin"
          @add="add"
          @remove="remove"
          class="text-base font-normal normal-case"
        />
        <!-- </label> -->

        <!-- <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Recipe Instructions
          <textarea
            class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
            type="text"
            placeholder=""
            v-model.lazy="recipe.instructions"
            autocomplete="off"
          />
        </label> -->

        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Finished Recipe Unit Type
          <input
            class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
            type="text"
            placeholder="(e.g. Oz)"
            v-model.lazy="recipe.unitType"
            autocomplete="off"
          />
        </label>

        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Total Yield of Recipe Units
          <input
            class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
            type="tel"
            placeholder="(e.g. 100)"
            v-model.lazy="recipe.unitYield"
            autocomplete="off"
          />
        </label>

        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Total Recipe Cost
          <div
            class="text-base text-center font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
          >
            {{ recipeCostById(recipe.id) | usd }}
          </div>
        </label>

        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Cost per Portion
          <div
            class="text-base text-center font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
          >
            {{ (recipeCostById(recipe.id) / (recipe.unitYield || 1)) | usd }}
          </div>
        </label>

        <div class="mt-6 flex flex-row justify-between text-lg text-gray-900">
          <span>Display in recipe list? </span>
          <s-switch class="" v-model="recipe.active" :disabled="!isAdmin" />
        </div>

        <div class="mt-6 flex flex-row justify-between text-lg text-gray-900">
          <span>Can this recipe be transferred? </span>
          <s-switch
            class=""
            v-model="recipe.transferable"
            :disabled="true"
            :title="'Disabled'"
          />
        </div>

        </fieldset>
        <div class="mt-6 flex flex-row justify-between">
          <button
            class="buttonOutline focus:shadow-outline focus:outline-none"
            type="button"
            @click="handleCancel"
          >
            Cancel
          </button>
          <button
            class="ml-3 buttonOutline focus:shadow-outline focus:outline-none"
            v-if="!this.new && isAdmin"
            type="button"
            @click="handleDelete"
          >
            Delete
          </button>
          <button
            v-if="isAdmin"
            class="ml-3 button focus:shadow-outline focus:outline-none"
            type="submit"
          >
            {{ this.new === true ? 'Create' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SSwitch from '@/components/SSwitch.vue'
import ListIngredients from '@/components/ListIngredients'
import { floatify } from '@/utils'

export default {
  name: 'ModalEditRecipe',
  data() {
    return {
      new: null,
      originalRecipe: {},
      recipe: {
        id: null,
        active: true,
        name: null,
        ingredients: {},
        unitType: null,
        unitYield: null,
        portionSize: null,
        instructions: null,
        qtyPerUnit: null,
        transferable: true // Default to true
      }
    }
  },
  components: {
    SSwitch,
    ListIngredients
  },
  computed: {
    ...mapGetters('recipes', ['recipes']),
    ...mapGetters('storeModule/products', ['products']),
    ...mapGetters('storeModule', ['recipeCostById']),
    ...mapGetters('user', ['isAdmin', 'isManager'])
  },
  methods: {
    ...mapActions('config', ['setFabVisible', 'setDragLock']),
    ...mapActions('recipes', {
      createRecipe: 'create',
      updateRecipe: 'updateItem',
      deleteRecipe: 'delete'
    }),
    floatify,
    add({ newIngredient, newAmount }) {
      this.$set(this.recipe.ingredients, newIngredient, newAmount)
    },
    remove(i) {
      this.$delete(this.recipe.ingredients, i)
    },
    hideModal() {
      this.$modal.hide('modal--edit-recipe')
    },
    beforeOpen(event) {
      // If an ID for a recipe was passed, get that recipe info, if not, set blank
      if (
        event &&
        event.params &&
        event.params.id &&
        this.recipes[event.params.id]
      ) {
        this.new = false
        // create a local copy, not a reference, for temporary editing
        this.recipe = JSON.parse(JSON.stringify(this.recipes[event.params.id]))
        // Set default for transferable if it doesn't exist
        if (
          !Object.prototype.hasOwnProperty.call(this.recipe, 'transferable')
        ) {
          this.recipe.transferable = true
        }

        if (!Object.prototype.hasOwnProperty.call(this.recipe, 'active'))
          this.recipe.active = true
      } else {
        this.new = true
        this.recipe.active = true
        this.recipe.transferable = true // Default for new recipes
      }
      // not using Vue.set since this doesn't need to be reactive? wrong..
      // this.originalRecipe = structuredClone(this.recipe) // not in all browsers yet
      this.originalRecipe = JSON.parse(JSON.stringify(this.recipe))
      // this.originalRecipe = { ...this.recipe }
      this.setFabVisible(false)
      this.setDragLock(true)
    },
    beforeClose() {
      this.originalRecipe = {}
      Object.keys(this.recipe).forEach((property) => {
        this.recipe[property] = null
      })
      this.recipe.ingredients = {}
      this.recipe.active = true
      this.setFabVisible(true)
      this.setDragLock(false)
    },
    handleDelete() {
      this.deleteRecipe(this.recipe.id)
      this.hideModal()
    },
    handleCancel() {
      this.hideModal()
    },
    handleConfirm() {
      if (this.new) {
        this.createRecipe({ ...this.recipe })
      } else {
        if (
          !(JSON.stringify(this.originalRecipe) === JSON.stringify(this.recipe))
        )
          this.updateRecipe({ id: this.recipe.id, data: { ...this.recipe } })
      }
      this.hideModal()
    }
  }
}
</script>
